import { SET_AUTH_TOKEN, SET_CURRENT_USER, SET_USER_ID } from '../actions/auth'

const initialState = {
    authToken: null, 
    currentUser: null,
    uid: null
}

export default function reducer(state = initialState, action) {
    if (action.type === SET_AUTH_TOKEN) {
        return Object.assign({}, state, {
            authToken: action.authToken
        })
    } else if (action.type === SET_CURRENT_USER) {
        return Object.assign({}, state, {
            currentUser: action.currentUser
        })
    }
    else if (action.type === SET_USER_ID) {
        return Object.assign({}, state, {
            uid: action.uid
        })
    }
    return state
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js